import { setUser } from './logging';
import Config from '../api/config';
import { appAuthenticated, startListening } from '../state';

startListening({
  actionCreator: appAuthenticated,
  effect: async () => {
    const userId = await Config.getUserId();

    if (userId) {
      setUser(userId);
    }
  },
});
